<template>
	<div class="scroll-shadow-wrapper">
		<slot />
		<div class="scroll-shadow-container" :class="{ 'is-hide': !isShow }">
			<div class="scroll-shadow" />
		</div>
	</div>
</template>

<script>
export default {
	name: 'ScrollShadow',
	props: {
		isShow: { type: Boolean },
	},
	data: () => ({
		isScrolledToBottom: false,
	}),
};
</script>

<style scoped lang="scss">
.scroll-shadow-wrapper {
	position: relative;
	height: 100%;

	.scroll-shadow-container {
		position: absolute;
		bottom: 0;
		left: 0;
		height: 8px;
		width: 100%;
		overflow: hidden;
		transform: rotate(180deg);

		&.is-hide .scroll-shadow {
			box-shadow: none;
		}
		.scroll-shadow {
			width: 100%;
			height: 1px;
			box-shadow: 0 1px 7px #000000;
		}
	}
}
</style>
